import React from 'react';
import connect from 'react-redux/lib/connect/connect';

import { ENTERPRISE_CARD_NAME, ENTERPRISE_CARD_PARTNER_EBC_ID } from '../../../../constants/ebon';

import { convertHtmlToReactDomWithParams } from '../../../../utils/htmlUtils';

import StepEbonComponent from '../../merchantcard/StepEbonComponent';
import { LoadingComponent } from '../../../loading/LoadingComponent';

const EnterpriseCardSteps = ({ i18n, ebonPartners }) => {
    const enterpriseCardPartner = ebonPartners.filter(
        p => p.ebcId === ENTERPRISE_CARD_PARTNER_EBC_ID
    )[0];

    const parameters = [
        {
            id: 0,
            partnerId: enterpriseCardPartner.id,
            title: i18n.ONLINE.TITLE,
            order: 1,
            steps: [
                {
                    id: 1,
                    number: 1,
                    text: convertHtmlToReactDomWithParams(i18n.ONLINE.STEPS.STEP1)
                },
                {
                    id: 2,
                    number: 2,
                    text: convertHtmlToReactDomWithParams(
                        i18n.ONLINE.STEPS.STEP2,
                        ENTERPRISE_CARD_NAME
                    )
                },
                {
                    id: 3,
                    number: 3,
                    text: convertHtmlToReactDomWithParams(
                        i18n.ONLINE.STEPS.STEP3,
                        ENTERPRISE_CARD_NAME
                    )
                }
            ]
        }
    ];

    return (
        <div>
            {enterpriseCardPartner ? (
                <StepEbonComponent partner={enterpriseCardPartner} parameters={parameters} />
            ) : (
                <LoadingComponent />
            )}
        </div>
    );
};

const mapStateToProps = (state, ownProps) => {
    return {
        i18n: state.i18n.page.ACCOUNT.EBONS.ENTERPRISE_CARD_STEPS,
        ebonPartners: state.ebon.ebonPartners
    };
};

export default connect(mapStateToProps)(EnterpriseCardSteps);



// WEBPACK FOOTER //
// ./src/components/pages/account/myebons/EnterpriseCardSteps.js